export default __webpack_public_path__ + "static/media/vertical_yellow_bar.243b4003.svg";